/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ itemName: NonNullable<unknown> }} Notifications_Message_Subject_Back_In_StockInputs */

const he_notifications_message_subject_back_in_stock = /** @type {(inputs: Notifications_Message_Subject_Back_In_StockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`חזר למלאי: ${i?.itemName}`)
};

const en_notifications_message_subject_back_in_stock = /** @type {(inputs: Notifications_Message_Subject_Back_In_StockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Back in stock: ${i?.itemName}`)
};

/**
* | output |
* | --- |
* | "Back in stock: {itemName}" |
*
* @param {Notifications_Message_Subject_Back_In_StockInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_message_subject_back_in_stock = /** @type {((inputs: Notifications_Message_Subject_Back_In_StockInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Subject_Back_In_StockInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_message_subject_back_in_stock(inputs)
	return en_notifications_message_subject_back_in_stock(inputs)
});